import * as React from 'react';

import { IDynamicComponentProps } from '../dynamic_component_props';

import SanitizedRender, {
  ALLOWED_TAGS,
  ALLOWED_ATTRIBUTES,
} from '../../components/sanitized_render';

export interface IProps extends IDynamicComponentProps {
  jumplinkSlug?: string;

  // legacy support
  htmlContent?: string;
  contentHtml?: string;
}

const ADDITIONAL_HTML_TAGS = Object.freeze([
  'h2',
  'iframe',
  'img',
]);

export default class MarkdownSectionHTML extends React.Component<IProps, null> {
  htmlContent() {
    return this.props.htmlContent || this.props.contentHtml;
  }

  render() {
    if (!this.htmlContent()) return null;

    return (
      <SanitizedRender
        className="markdown-section"
        html={this.htmlContent()}
        htmlTag="div"
        allowedTags={ALLOWED_TAGS.concat(ADDITIONAL_HTML_TAGS)}
        allowedAttributes={ALLOWED_ATTRIBUTES.concat(['style'])}
        id={this.props.jumplinkSlug}
      />
    );
  }
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/cms/components/markdown_section_html.tsx